import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, IconButton, Typography, Divider, Box, Dialog, DialogContent } from '@mui/material';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import NativeOrWeb from '../../../utils/native';

const ECardWeChatDialog = props => {
  const { open, onClose, adviserInfo, intl, wechatId, wechatUrl } = props;
  const onClickWechat = async () => {
    if (!wechatId) {
      return;
    }

    // Toast only when the copy actually landed — see the note on `copyToClipboard` for
    // what the web path can and cannot promise. The id stays readable either way.
    let copied = false;
    try {
      copied = await NativeOrWeb.copyToClipboard(wechatId);
    } catch (error) {
      // leave copied false
    }

    if (copied) {
      toast.info(IconToast('info', intl.formatMessage({ id: 'wechat-msg-copied' })), { className: 'new-toast' });
    }
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent style={{ textAlign: 'center', padding: 24 }}>
        {wechatUrl && (
          <>
            <QRCode size={120} style={{ height: 'auto' }} value={wechatUrl} viewBox={`0 0 64 64`} />
            <Typography style={{ marginTop: 12 }}>
              {' '}
              {intl.formatMessage({ id: 'open-wechat-and-scan-above-qr-code' })}
            </Typography>
          </>
        )}
        {wechatId && (
          <Typography onClick={onClickWechat} style={{ cursor: 'pointer' }}>
            {intl.formatMessage({ id: 'or-add-wechat-id' })} {wechatId}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default injectIntl(ECardWeChatDialog);
